module.exports = __webpack_public_path__ + "static/media/FrancescoPedulli.9913229b.jpg";